/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Default_SuffixInputs */

const en_orders_default_suffix = /** @type {(inputs: Orders_Default_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Default)`)
};

const es_orders_default_suffix = /** @type {(inputs: Orders_Default_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Predeterminada)`)
};

/**
* | output |
* | --- |
* | "(Default)" |
*
* @param {Orders_Default_SuffixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_default_suffix = /** @type {((inputs?: Orders_Default_SuffixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Default_SuffixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_default_suffix(inputs)
	return es_orders_default_suffix(inputs)
});